// Plugin para aplicar automaticamente as configurações do sistema
export default {
  install(Vue, options = {}) {
    // Flag para evitar aplicações múltiplas
    let lastAppliedConfig = null;
    
    // Método global para aplicar configurações do sistema
    Vue.prototype.$applySystemConfig = function(config, isLoading = false) {
      if (!config) return;
      
      // Não aplicar configurações se ainda estiver carregando
      if (isLoading) return;
      
      // Evitar aplicar a mesma configuração múltiplas vezes
      const configKey = `${config.primary_color}-${config.app_name}`;
      if (lastAppliedConfig === configKey) {
        return;
      }
      lastAppliedConfig = configKey;
      
      // Atualizar variáveis CSS imediatamente
      if (config.primary_color) {
        document.documentElement.style.setProperty('--primary-color', config.primary_color);
      }
      
      if (config.secondary_color) {
        document.documentElement.style.setProperty('--secondary-color', config.secondary_color);
      }
      
      if (config.app_name) {
        document.documentElement.style.setProperty('--system-app-name', `'${config.app_name}'`);
        // Atualizar título da página
        document.title = config.app_name;
      }
      
      // Atualizar tema do Vuetify (compatível com v1.x)
      if (this.$vuetify && this.$vuetify.theme) {
        if (config.primary_color) {
          this.$vuetify.theme.primary = config.primary_color;
        }
        if (config.secondary_color) {
          this.$vuetify.theme.secondary = config.secondary_color;
        }
      }
      
      // Atualizar favicon
      if (config.favicon_url) {
        this.$updateFavicon(config.favicon_url);
      }
      
      // Atualizar meta theme-color
      if (config.pwa && config.pwa.theme_color) {
        this.$updateThemeColor(config.pwa.theme_color);
      }
    };
    
    // Método para atualizar favicon
    Vue.prototype.$updateFavicon = function(faviconUrl) {
      const faviconSelectors = [
        'link[rel="icon"]',
        'link[rel="shortcut icon"]',
        'link[rel="apple-touch-icon"]'
      ];
      
      faviconSelectors.forEach(selector => {
        let link = document.querySelector(selector);
        if (link) {
          link.href = faviconUrl;
        }
      });
      
      // Garantir que pelo menos um link de favicon existe
      if (!document.querySelector('link[rel="icon"]')) {
        const favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = faviconUrl;
        document.head.appendChild(favicon);
      }
    };
    
    // Método para atualizar theme-color meta tag
    Vue.prototype.$updateThemeColor = function(themeColor) {
      let themeColorMeta = document.querySelector('meta[name="theme-color"]');
      
      if (!themeColorMeta) {
        themeColorMeta = document.createElement('meta');
        themeColorMeta.name = 'theme-color';
        document.head.appendChild(themeColorMeta);
      }
      
      themeColorMeta.content = themeColor;
    };
    
    // Método para obter configuração baseada no parceiro (futuro uso)
    Vue.prototype.$getPartnerConfig = function() {
      // Aqui pode ser implementada lógica para buscar configurações específicas do parceiro
      // baseado no usuário logado ou contexto atual
      return null;
    };
    
    // Mixin global para aplicar configurações automaticamente
    Vue.mixin({
      computed: {
        $systemConfig() {
          return this.$store ? this.$store.getters['system/systemConfiguration'] : null;
        }
      },
      
      watch: {
        $systemConfig: {
          handler(newConfig) {
            if (newConfig) {
              const isLoading = this.$store ? this.$store.getters['system/isLoading'] : false;
              this.$applySystemConfig(newConfig, isLoading);
            }
          },
          immediate: true,
          deep: true
        }
      }
    });
  }
};